import actionTypes from "./types";

/** Org actions */
export const setOrg = (org) => {
  return {
    type: actionTypes.SET_ORG,
    payload: {
      currentOrg: org,
    },
  };
};

export const setOrgs = (orgs) => {
  return {
    type: actionTypes.SET_ORGS,
    payload: {
      orgs: orgs,
    },
  };
};
export const clearOrg = () => {
  return {
    type: actionTypes.CLEAR_ORG,
  };
};

export const setGroups = (groups) => {
  return {
    type: actionTypes.SET_GROUPS,
    payload: {
      groups,
    },
  };
};

export const setGroup = (group, index) => {
  return {
    type: actionTypes.SET_GROUP,
    payload: {
      group,
      index,
    },
  };
};

export const setItems = (items) => {
  return {
    type: actionTypes.SET_ITEMS,
    payload: {
      items,
    },
  };
};

export const setItem = (item, groupIndex, index) => {
  return {
    type: actionTypes.SET_ITEM,
    payload: {
      item,
      groupIndex,
      index,
    },
  };
};

/**Work */
export const setWorkInstruction = (workInstruction) => {
  return {
    type: actionTypes.SET_WORK_INSTRUCTION,
    payload: {
      workInstruction,
    },
  };
};

/* Work Events */
export const setWorkEventCustomer = (customer) => {
  return {
    type: actionTypes.SET_WORK_EVENT_CUSTOMER,
    payload: {
      customer,
    },
  };
};

export const setWorkEventPlaces = (places) => {
  return {
    type: actionTypes.SET_WORK_EVENT_PLACES,
    payload: {
      places,
    },
  };
};

export const clearPlaces = () => {
  return {
    type: actionTypes.CLEAR_PLACES,
  };
};

export const clearCustomerAndPlaces = () => {
  console.log(
    "🚀 ~ file: index.js ~ line 99 ~ clearCustomerAndPlaces ~ clearCustomerAndPlaces"
  );
  return {
    type: actionTypes.CLEAR_CUST_AND_PLACES,
  };
};
